import {
  IBrugereFields,
  IDataudtraekFields,
  IMailskabelonFields,
  IPrismatrixFields,
} from "../../interfaces/admin";
import { IColumn } from "../../interfaces/table";

export const defaultDataudtraekColumns: IColumn<IDataudtraekFields>[] = [
  {
    active: true,
    field: "navn",
    format: "string",
    title: "Navn",
  },
  {
    active: true,
    field: "beskrivelse",
    format: "string",
    title: "Beskrivelse",
  },
];

export const defaultBrugerColumns: IColumn<IBrugereFields>[] = [
  {
    active: true,
    field: "initialer",
    format: "string",
    title: "Initialer",
  },
  {
    active: true,
    field: "navn",
    format: "string",
    title: "Navn",
  },
  {
    active: true,
    field: "titel",
    format: "string",
    title: "Titel",
  },
  {
    active: true,
    field: "email",
    format: "string",
    title: "Email",
  },
  {
    active: false,
    field: "domainUserName",
    format: "string",
    title: "Domæne brugernavn",
  },
  {
    active: false,
    field: "id",
    format: "string",
    title: "Id",
  },
];

export const defaultPrissaetningColumns: IColumn<IPrismatrixFields>[] = [
  {
    active: true,
    field: "fmuKursusholdDagspris",
    format: "string",
    title: "Kursus Dagspris",
  },
  {
    active: true,
    field: "fmuKursusholdOvernatningspris",
    format: "string",
    title: "Kursus Overnatningspris",
  },
  {
    active: true,
    field: "fmuKursusholdAendringsGebyr",
    format: "string",
    title: "Kursus Ændringsgebyr",
  },
  {
    active: true,
    field: "retssagsproeve",
    format: "string",
    title: "Retssagsprøve",
  },
  {
    active: true,
    field: "abonnement",
    format: "string",
    title: "Abonnement",
  },
  {
    active: true,
    field: "bidragTilAS",
    format: "string",
    title: "Bidrag Til AS",
  },
  {
    active: true,
    field: "kontingentKAF",
    format: "string",
    title: "Kontingent KAF",
  },
  {
    active: true,
    field: "asForsikringsordning",
    format: "string",
    title: "AS Forsikringsordning",
  },
];

export const defaultMailskabelonColumns: IColumn<IMailskabelonFields>[] = [
  {
    field: "navn",
    active: true,
    format: "string",
    title: "Navn",
  },
  {
    field: "afsender",
    active: true,
    format: "string",
    title: "Afsender",
  },
  {
    field: "type",
    active: true,
    format: "string",
    title: "Type",
  },
  {
    field: "vedhaeftelser",
    active: true,
    format: "number",
    title: "Vedhæftelser",
  },
];

export const defaultKodelisteEfteruddannelsestyperColumns: IColumn<KodelisteEfteruddannelsestyperFields>[] =
  [
    {
      field: "navn",
      title: "Navn",
      active: true,
      format: "string",
    },
    {
      field: "nr",
      title: "Nr.",
      active: true,
      format: "number",
    },
    {
      field: "formaal",
      title: "Formål",
      active: true,
      format: "number",
    },
    {
      field: "maxLektioner",
      active: true,
      format: "number",
      title: "Maks lektioner",
    },
    {
      field: "overfoerTilMax",
      active: true,
      format: "boolean",
      title: "Overfør til maks",
    },
    {
      field: "overfoerPrioritet",
      active: true,
      format: "number",
      title: "Overførselsprioritet",
    },
  ];

export const defaultHotellerColumns: IColumn<HotellerFields>[] = [
  {
    field: "navn1",
    title: "Navn 1",
    active: true,
    format: "string",
  },
  {
    field: "navn2",
    title: "Navn 2",
    active: false,
    format: "string",
  },
  {
    field: "sted",
    title: "Sted",
    active: true,
    format: "string",
  },
  {
    field: "tlfNr",
    title: "Tlf. nr.",
    active: true,
    format: "string",
  },
  {
    field: "faxNr",
    title: "Fax nr.",
    active: false,
    format: "string",
  },
  {
    field: "attPerson",
    title: "Kontaktperson",
    active: true,
    format: "string",
  },
  {
    field: "eMail",
    title: "E-mail",
    active: true,
    format: "string",
  },
  {
    field: "webAdresse",
    title: "Web adresse",
    active: true,
    format: "string",
  },
  {
    field: "aflysUgeHotel",
    title: "Aflys uge hotel",
    active: true,
    format: "number",
  },
  {
    field: "aflysUgeVærelse",
    title: "Aflys uge værelse",
    active: true,
    format: "number",
  },
  {
    field: "opretDato",
    title: "Opret dato",
    active: false,
    format: "date",
  },
  {
    field: "opretInit",
    title: "Opret init",
    active: false,
    format: "string",
  },
  {
    field: "retteDato",
    title: "Rette dato",
    active: false,
    format: "date",
  },
  {
    field: "retteInit",
    title: "Rette init",
    active: false,
    format: "string",
  },
];

export const defaultInteresserColumns: IColumn<InteresserFields>[] = [
  {
    field: "navn",
    title: "Navn",
    active: true,
    format: "string",
  },
  {
    field: "beskrivelse",
    title: "Beskrivelse",
    active: true,
    format: "string",
  },
  {
    field: "forkortelse",
    title: "Forkortelse",
    active: true,
    format: "string",
  },
];

export const defaultUdenlandskAdvokatsamfundColumns: IColumn<UdenlandskAdvokatsamfundFields>[] =
  [
    {
      field: "navn",
      title: "Navn",
      active: true,
      format: "string",
    },
    {
      field: "beskrivelse",
      title: "Beskrivelse",
      active: true,
      format: "string",
    },
  ];

export const defaultUdvalgColumns: IColumn<UdvalgFields>[] = [
  {
    field: "navn",
    title: "Navn",
    active: true,
    format: "string",
  },
  {
    field: "beskrivelse",
    title: "Beskrivelse",
    active: true,
    format: "string",
  },
  {
    field: "udvalgNr",
    title: "Udvalgsnummer",
    active: true,
    format: "string",
  },
  {
    field: "periodeFraDato",
    title: "Periode fra dato",
    active: true,
    format: "date",
  },
  {
    field: "periodeTilDatoInklusiv",
    title: "Periode til dato inklusiv",
    active: true,
    format: "date",
  },
];

export const defaultKodelisteSanktionstyperColumns: IColumn<KodelisteSanktionstyperFields>[] =
  [
    {
      field: "navn",
      title: "Navn",
      active: true,
      format: "string",
    },
    {
      field: "nr",
      title: "Nr.",
      active: true,
      format: "number",
    },
    {
      field: "udvidetLevetid",
      title: "Udvidet levetid",
      active: true,
      format: "boolean",
    },
    {
      field: "deaktiveret",
      title: "Deaktiveret",
      active: true,
      format: "boolean",
    },
  ];

export const defaultKodelisteNavnOgNrColumns: IColumn<KodelisteNavnOgNrFields>[] =
  [
    {
      field: "navn",
      title: "Navn",
      active: true,
      format: "string",
    },
    {
      field: "nr",
      title: "Nr.",
      active: true,
      format: "number",
    },
  ];
